import { AlertButton } from '@shared/alert/alertButton';
import { StringUtils } from '@shared/util/string-utils';
import { FileUtils } from '@shared/util/file-utils';
import { SaveCompositeArticleService } from '../../../service/save-composite-article.service';
import { ProjectModel } from '../../../model/project.model';
import { AlertHelper } from '@shared/alert/alert.helper';
import { ProjectVO } from '../../../model/vo/project.vo';
import { cloneDeep } from 'lodash';
import { DimensionsVO } from '../../../model/vo/dimensions.vo';
import { ProjectOptionUtils } from '../../project/util/project-option.utils';
import { ProjectExportDataService } from './project-export-data.service';
import { ProjectDimensionsService } from '../../project/service/project-dimensions.service';
import { Injectable } from '@angular/core';
import { ProjectService } from './project.service';

@Injectable({ providedIn: 'root' })
export class CalculationProjectExportService {

  constructor(
    private projectExportDataService: ProjectExportDataService,
    private alertHelper: AlertHelper,
    private projectModel: ProjectModel,
    private projectDimensionsService: ProjectDimensionsService,
    private projectService: ProjectService,
    private saveCompositeArticleService: SaveCompositeArticleService,
  ) { }

  public exportProjectToCalculation(projectVO: ProjectVO): void {
    const projectCopy: ProjectVO = cloneDeep(projectVO);
    this.replaceOptionsWithDimensions(projectCopy);

    this.projectExportDataService.exportProjectToCalculation(projectCopy).subscribe({
      next: (data: ArrayBuffer) => {
        this.calculationExportFinished(data);
        this.clearCorridorInformation();
      },
      error: (error) => {
        this.calculationExport_failure();
        this.clearCorridorInformation();
      }
    });
  }

  private replaceOptionsWithDimensions(project: ProjectVO): void {
    const projectDimensions: DimensionsVO = this.projectDimensionsService.calculateDimensions(project);
    ProjectOptionUtils.replaceOptionsValue(project.options, '145', projectDimensions.length.toString());
    ProjectOptionUtils.replaceOptionsValue(project.options, '146', projectDimensions.width.toString());
    ProjectOptionUtils.replaceOptionsValue(project.options, '147', projectDimensions.height.toString());
  }

  private calculationExportFinished(calculationXML: ArrayBuffer): void {
    this.alertHelper.showAlert('exportCalculation.title.export_finished', 'exportCalculation.message.export_finished', undefined,
      [AlertButton.OK], "info").then(() => {
      const fileName: string = StringUtils.sanitizeFileName(this.projectService.getProjectName(this.projectModel.currentProject));
      FileUtils.saveBinaryFile(fileName, calculationXML, '.xml');
    });
  }

  private calculationExport_failure(): void {
    this.alertHelper.showError('exportCalculation.title.export_failed', 'exportCalculation.message.export_failed');
  }

  private clearCorridorInformation(): void {
    this.saveCompositeArticleService.clearCompositeConnectionCorridor(this.projectModel.currentProject);
  }
}
